import { AuthorizationType } from 'consts';
import React, { PureComponent } from 'react';

import BlikInput from './Input/BlikInput';
import BlikRedirect from './redirect/BlikRedirect';

interface IProps extends IAccordionWrapper, IContext {
  paymentMethods: IMethod[];
  formData: IFormData;
}

class Blik extends PureComponent<IProps> {
  render() {
    const { authorizationType } = this.props;

    return (
      <div>
        {authorizationType === AuthorizationType.REDIRECT ? (
          <BlikRedirect {...this.props} />
        ) : (
          <BlikInput {...this.props} />
        )}
      </div>
    );
  }
}

export default Blik;
